import PropTypes from 'prop-types';
import React from 'react';

import { colors } from '../../../common/styles/style-constants';

const Toothbrush = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 37.3 49.9"
    fill={color}
  >
    <path d="M24.7 21.8c-.4 0-.8-.2-1.1-.5l-6.4-6.4c-.6-.6-.6-1.6 0-2.2.6-.6 1.6-.6 2.2 0l6.4 6.4c.6.6.6 1.6 0 2.2-.3.3-.7.5-1.1.5zM28.7 17.8c-.4 0-.8-.2-1.1-.5l-7.7-7.8c-.6-.6-.6-1.6 0-2.2.6-.6 1.6-.6 2.2 0l7.7 7.8c.6.6.6 1.6 0 2.2-.3.3-.7.5-1.1.5zM20.1 25.2c-.4 0-.8-.2-1.1-.5l-4.5-4.5c-.6-.6-.6-1.6 0-2.2.6-.6 1.6-.6 2.2 0l4.5 4.5c.6.6.6 1.6 0 2.2-.3.4-.7.5-1.1.5zM1.6 44.4c-.4 0-.9-.2-1.2-.5-.6-.6-.5-1.7.1-2.2L10.9 32l-7.2-7.3c-.6-.6-.6-1.6 0-2.2.6-.6 1.6-.6 2.2 0l8.4 8.4c.3.3.5.7.5 1.2 0 .4-.2.8-.5 1.1L2.7 43.9c-.3.3-.7.5-1.1.5zM16.5 29c-.4 0-.8-.2-1.1-.5l-5.3-5.2c-.6-.6-.6-1.6 0-2.2.6-.6 1.6-.6 2.2 0l5.3 5.2c.6.6.6 1.6 0 2.2-.3.4-.7.5-1.1.5z" />
    <path d="M5.1 25.2c-1.2 0-2.4-.2-3.5-.5-.5-.1-.9-.5-1.1-1-.3-1 0-1.6 3-5.9.4-.5.7-.9.8-1.1.9-1.4 1.2-3.2 1.5-5 .4-2.3.8-4.7 2.4-6.8 2.4-3.2 6.5-4.9 12-4.9 1.5 0 3.1.1 4.8.4 1.8.3 2.8 1 3.1 2.2.3 1.4-.7 3-3 4.5-2.6 1.7-4.6 3.3-5.6 6.3-1.3 3.8-2.7 8.2-7.5 10.3-2.5 1-4.8 1.5-6.9 1.5zM4.5 22h.6c1.7 0 3.6-.4 5.5-1.3 3.3-1.4 4.4-4.2 5.8-8.3 1.3-3.9 4-6 6.9-7.9.5-.4 1-.7 1.2-1-1.5-.2-2.9-.4-4.3-.4-3.1 0-7.2.6-9.4 3.6-1.1 1.5-1.4 3.4-1.8 5.5-.4 2-.7 4.2-1.9 6.1-.1.2-.4.7-.9 1.3-.5.6-1.2 1.6-1.7 2.4z" />
    <path d="M7.6 49.9c-.3 0-.6-.1-.9-.3-.7-.5-.9-1.5-.4-2.2.2-.3 4.6-6.5 10.8-12.7 2.5-2.5 5.1-5.1 7.4-7.5 4.2-4.2 7.5-7.6 8.8-8.7.9-.8.9-1.4.9-1.6 0-1.1-1.3-2.4-1.8-2.8L24.2 6c-.6-.6-.6-1.6 0-2.2.6-.6 1.6-.6 2.2 0l7.9 7.9c.6.4 2.9 2.5 2.9 5.1 0 1.1-.3 2.6-2 4.1-1.2 1-4.6 4.5-8.6 8.5-2.3 2.4-4.9 5-7.4 7.5-6 6-10.4 12.2-10.4 12.3-.3.5-.7.7-1.2.7z" />
  </svg>
);
Toothbrush.defaultProps = {
  color: colors.blue,
};

Toothbrush.propTypes = {
  color: PropTypes.string,
};

export default Toothbrush;
